import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import { createAsyncReducer } from 'redux-easy-async';
import * as Actions from "../actions";
export default createAsyncReducer( // make Actions into a real array instead of "array like"
Object.keys(Actions).map(function (key) {
  return Actions[key];
}));